


import Vue from 'vue'

export default Vue.extend({
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    const infoWindow = new this.google.maps.InfoWindow({
      content: `<div>test</div>`,
    })
  },
})
